import call from './call.js'

export default {
    create: (slug, uid) => {
        return call.post('/create', { slug, uid })
    },
    store: (slug, uid, results) => {
        return call.post('/store', { slug, uid, results })
    },
}
